import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict,
  platformTitleDict,
  superviseInstitutionDict
} from '@/dictionary/system'

/**
 * 招标采购 - 备案采购
 */
export default {
  path: 'supplement',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '备案采购',
    icon: 'icon-side_purchase_record',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
  roles: [
    platformFunctionModuleDict.PURCHASER.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [superviseInstitutionDict.JXGZW.value],

  children: [
    // 备案列表
    {
      path: 'list',
      name: `SupplementList`,
      component: '/procure-views/purchase/supplement/list',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '备案列表',
        cache: true,
        hidden: true,
        pageComponentName: 'SupplementList'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [
        {
          platformId: platformTitleDict.JXIC.value,
          menuName: '进程交易或补录项目'
        }
      ],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [superviseInstitutionDict.JXGZW.value]
    },

    // 项目登记
    {
      path: ':registrationId?/register',
      name: `SupplementRegister`,
      component: '/procure-views/purchase/supplement/register/index',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '项目登记',
        hidden: true,
        needFormKey: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [superviseInstitutionDict.JXGZW.value]
    },

    // 发布预览
    {
      path: ':registrationId?/register/preview',
      name: `SupplementRegisterPreview`,
      component: '/procure-views/purchase/supplement/register/preview',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '发布预览',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [superviseInstitutionDict.JXGZW.value]
    },

    // 结果备案
    {
      path: ':registrationId/record',
      name: `SupplementRecord`,
      component: '/procure-views/purchase/supplement/record',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '结果备案',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [superviseInstitutionDict.JXGZW.value]
    },

    // 项目详情
    {
      path: ':registrationId/detail',
      name: `SupplementDetail`,
      component: '/procure-views/purchase/supplement/detail',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '项目详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [superviseInstitutionDict.JXGZW.value]
    }
  ]
}
